var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-1vh bg-background",attrs:{"id":"ht-progressbar"}},[_c('div',{staticClass:"h-1vh w-full",class:{'play': _vm.play},style:(_vm.BarStyle),attrs:{"id":"bar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }